// lessonService.js
import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

// Reference to Firestore collection
const lessonsCollection = collection(db, "lessons");

// Get all lessons
export const getLessons = async () => {
  const snapshot = await getDocs(lessonsCollection);
  return snapshot.docs
    .map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }))
    .sort((a, b) => a.createdAt - b.createdAt);
};

// Create new lesson
export const createLesson = async (lessonData) => {
  const payload = {
    ...lessonData,
    createdAt: Date.now(),
    updatedAt: Date.now(),
  };
  const docRef = await addDoc(lessonsCollection, payload);
  return docRef.id;
};

// Update lesson
export const updateLesson = async (lessonId, updatedData) => {
  const payload = {
    ...updatedData,
    updatedAt: Date.now(),
  };
  const lessonDoc = doc(db, "lessons", lessonId);
  await updateDoc(lessonDoc, payload);
};

// Delete lesson
export const deleteLesson = async (lessonId) => {
  const lessonDoc = doc(db, "lessons", lessonId);
  await deleteDoc(lessonDoc);
};
